import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable no-process-env */
var hosts = ['dev-godaddy.com', 'dev-secureserver.net', 'dev-123-reg.co.uk', 'test-godaddy.com', 'test-secureserver.net', 'test-123-reg.co.uk', 'ote-godaddy.com', 'ote-secureserver.net', 'godaddy.com', 'secureserver.net', '123-reg.co.uk'];
var defaultHost = 'godaddy.com';

/**
 * @description Returns the asset bucket name
 * If the bucket is provided, it returns the bucket name.
 * If the url is for Cart, it prepends '/px-assets-recore' to the bucket name.
 * @param {object} props - the props of the Recommendations component
 * @param {string} props.bucket - the bucket name to use
 * @param {string} baseUrl - the base url of the current site
 * @returns {string} - the asset bucket name
 */
export function getAssetBucket(props, baseUrl) {
  var bucket = props.bucket;
  var baseBucket = baseUrl.includes('cart') ? '/px-assets-recore' : '';
  if (bucket) {
    return "".concat(baseBucket, "/").concat(bucket);
  }
  return baseBucket;
}

/**
 * Get the current environment from the site url
 * @param {string} hostUrl - the url of the current site (optional)
 * @returns {string} - the environment of the current site
 */
export function getEnv(hostUrl) {
  var env = 'prod';
  var host = getHost(hostUrl) || '';
  if (host.startsWith('dev')) {
    env = 'dev';
  } else if (host.startsWith('test')) {
    env = 'test';
  } else if (host.startsWith('local')) {
    env = 'local';
  }
  return env;
}

/**
 * Get the client window object
 * @returns {object} - the client window object
 */
export function getClientWindowObject() {
  var _window, _global, _global$window;
  if (typeof window !== 'undefined' && (_window = window) !== null && _window !== void 0 && _window.location) {
    return window;
  }
  if (typeof global !== 'undefined' && (_global = global) !== null && _global !== void 0 && (_global$window = _global.window) !== null && _global$window !== void 0 && _global$window.location) {
    return global.window;
  }
  return {
    location: {
      hostname: defaultHost
    }
  };
}

/**
 * Get the url for the recommendations api
 * @param {object} props property bucket containing the below args
 * @param {string} props.hostUri the url to parse the host from to construct the API url. Used for Server Rendering (optional)
 * @returns {string} - base recommendations API url for the current site
 */
export function getBaseApiUrl() {
  var _process, _process$env;
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var hostUri = props.hostUri;
  if (typeof process !== 'undefined' && (_process = process) !== null && _process !== void 0 && (_process$env = _process.env) !== null && _process$env !== void 0 && _process$env.STORYBOOK_CHECKOUT_API) {
    return process.env.STORYBOOK_CHECKOUT_API;
  }
  var subdomain = 'rerec';
  var apiPath = '';
  var envType = getEnv(hostUri);
  if (envType === 'prod') {
    subdomain = 'cart';
    apiPath = '/checkoutapi';
  }
  var hostName = getHost(hostUri);
  var base = "https://".concat(subdomain, ".").concat(hostName);
  var baseApiUrl = "".concat(base).concat(apiPath);
  return baseApiUrl;
}

/**
 * Get the hostname for the current site
 * @param {string} hostUrl - the url of the current site (optional)
 * @returns {string} - the hostname of the current site
 */
export function getHost(hostUrl) {
  var _hosts$find;
  if (!hostUrl) {
    hostUrl = getClientHostname();
  }
  var hostName = (_hosts$find = hosts.find(function (host) {
    var _hostUrl, _hostUrl$includes;
    return (_hostUrl = hostUrl) === null || _hostUrl === void 0 ? void 0 : (_hostUrl$includes = _hostUrl.includes) === null || _hostUrl$includes === void 0 ? void 0 : _hostUrl$includes.call(_hostUrl, host);
  })) !== null && _hosts$find !== void 0 ? _hosts$find : defaultHost;
  return hostName;
}

/**
 * Get the url of the current site
 * @param {object} [clientWindow] - The Window object
 * @param {Location} clientWindow.location - The Location object
 * @param {string} clientWindow.location.hostname - The hostname of the current site
 * @returns {string} - the url of the current site
 */
export function getClientHostname(clientWindow) {
  var _clientWindow, _clientWindow$locatio, _clientWindow2, _clientWindow2$locati;
  if (typeof clientWindow === 'undefined' || !((_clientWindow = clientWindow) !== null && _clientWindow !== void 0 && (_clientWindow$locatio = _clientWindow.location) !== null && _clientWindow$locatio !== void 0 && _clientWindow$locatio.hostname)) {
    clientWindow = getClientWindowObject();
  }
  return (_clientWindow2 = clientWindow) === null || _clientWindow2 === void 0 ? void 0 : (_clientWindow2$locati = _clientWindow2.location) === null || _clientWindow2$locati === void 0 ? void 0 : _clientWindow2$locati.hostname;
}

/**
 * Get the search params for the current url
 * @param {object} [clientWindow] - The Window object
 * @param {Location} clientWindow.location - The Location object
 * @param {string} clientWindow.location.search - The search param part of the current url
 * @returns {object} - the search params for the current url
 */
export function getUrlParams(clientWindow) {
  var _clientWindow3, _clientWindow3$locati, _clientWindow4, _clientWindow4$locati;
  if (typeof clientWindow === 'undefined' || !((_clientWindow3 = clientWindow) !== null && _clientWindow3 !== void 0 && (_clientWindow3$locati = _clientWindow3.location) !== null && _clientWindow3$locati !== void 0 && _clientWindow3$locati.search)) {
    clientWindow = getClientWindowObject();
  }
  var searchParams = new URLSearchParams((_clientWindow4 = clientWindow) === null || _clientWindow4 === void 0 ? void 0 : (_clientWindow4$locati = _clientWindow4.location) === null || _clientWindow4$locati === void 0 ? void 0 : _clientWindow4$locati.search);
  return Object.fromEntries(searchParams.entries());
}

/**
 * Retrieves and sanitizes the condition overrides data from localStorage.
 * Returns an object with an elements array containing the IDs of overridden elements.
 * Ensures the data structure is valid and handles any parsing errors gracefully.
 * @returns {Object} Object with elements array, or empty object with empty elements array if no valid data
 * @example
 * // Returns:
 * {
 *   elements: ["element-id-1", "element-id-2"]
 * }
 */
export function getConditionOverrides() {
  try {
    var storedData = localStorage.getItem('recoreDebugger');
    if (!storedData) {
      return [];
    }
    var parsedData = JSON.parse(storedData);
    var overrideData = (parsedData === null || parsedData === void 0 ? void 0 : parsedData.recoreConditionOverrides) || [];
    if (!Array.isArray(overrideData)) {
      return [];
    }

    // Ensure elements is an array and contains only valid strings
    var elements = Array.isArray(overrideData) ? overrideData.filter(function (id) {
      return typeof id === 'string' && id.length > 0;
    }) : [];

    // Update localStorage with sanitized data
    localStorage.setItem('recoreDebugger', JSON.stringify(_objectSpread(_objectSpread({}, parsedData), {}, {
      recoreConditionOverrides: elements
    })));
    return elements;
  } catch (e) {
    return [];
  }
}
//# sourceMappingURL=util.js.map